import type React from 'react';
import { useAuthState } from '../context/AuthContext';
import AuthLanding from '../pages/AuthLanding';
import LoginGate from '../pages/LoginGate';
import FullScreenMessage from './FullScreenMessage';

export default function RouteGuard({ children }: { children: React.ReactNode }): JSX.Element {
  const { loading, accessToken, user } = useAuthState();

  if (loading) {
    return <FullScreenMessage text="Loading your account…" />;
  }
  if (!accessToken) {
    return <AuthLanding />;
  }
  if (!user) {
    return <LoginGate text="Could not verify your session. Please log in again." />;
  }

  return <>{children}</>;
}
